import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useIsCouponsEnabled = () => {
  return useIsFeatureActive('coupons').isActive;
};
